var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import classnames from 'classnames';
// removed import of scss-style
import { Hr, Label, Paragraph } from '../elements/index';
const NotationBox = props => {
    const { className, title, body } = props, rest = __rest(props, ["className", "title", "body"]);
    return (React.createElement("div", Object.assign({ className: classnames('NotationBox', className) }, rest),
        React.createElement("div", { className: 'NotationBox__Point' }),
        React.createElement("div", { className: 'NotationBox__Content' },
            React.createElement(Label, null, title),
            React.createElement(Hr, null),
            React.createElement(Paragraph, { small: true }, body))));
};
export default NotationBox;
